var map = {
	"./App": 179,
	"./App.tsx": 179,
	"./app": 474,
	"./app.json": 474,
	"./assets/adaptive-icon.png": 639,
	"./assets/cart.png": 475,
	"./assets/cooking.gif": 476,
	"./assets/en.svg": 467,
	"./assets/favicon.png": 640,
	"./assets/fonts/Poppins/OFL.txt": 641,
	"./assets/fonts/Poppins/Poppins-Black.ttf": 477,
	"./assets/fonts/Poppins/Poppins-BlackItalic.ttf": 642,
	"./assets/fonts/Poppins/Poppins-Bold.ttf": 478,
	"./assets/fonts/Poppins/Poppins-BoldItalic.ttf": 643,
	"./assets/fonts/Poppins/Poppins-ExtraBold.ttf": 479,
	"./assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf": 644,
	"./assets/fonts/Poppins/Poppins-ExtraLight.ttf": 645,
	"./assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf": 646,
	"./assets/fonts/Poppins/Poppins-Italic.ttf": 647,
	"./assets/fonts/Poppins/Poppins-Light.ttf": 480,
	"./assets/fonts/Poppins/Poppins-LightItalic.ttf": 648,
	"./assets/fonts/Poppins/Poppins-Medium.ttf": 481,
	"./assets/fonts/Poppins/Poppins-MediumItalic.ttf": 649,
	"./assets/fonts/Poppins/Poppins-Regular.ttf": 482,
	"./assets/fonts/Poppins/Poppins-SemiBold.ttf": 650,
	"./assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf": 651,
	"./assets/fonts/Poppins/Poppins-Thin.ttf": 652,
	"./assets/fonts/Poppins/Poppins-ThinItalic.ttf": 653,
	"./assets/fr.svg": 468,
	"./assets/icon.png": 654,
	"./assets/icons/allergens/allergen_celery.png": 655,
	"./assets/icons/allergens/allergen_crustacena.png": 656,
	"./assets/icons/allergens/allergen_eggs.png": 657,
	"./assets/icons/allergens/allergen_fish.png": 658,
	"./assets/icons/allergens/allergen_lupin.png": 659,
	"./assets/icons/allergens/allergen_milk.png": 660,
	"./assets/icons/allergens/allergen_molluscs.png": 661,
	"./assets/icons/allergens/allergen_mustard.png": 662,
	"./assets/icons/allergens/allergen_peanut.png": 663,
	"./assets/icons/allergens/allergen_sesame.png": 664,
	"./assets/icons/allergens/allergen_soya.png": 665,
	"./assets/icons/allergens/allergen_sulphurdioxide.png": 666,
	"./assets/icons/allergens/allergen_treenut.png": 667,
	"./assets/icons/allergens/allergen_wheat.png": 668,
	"./assets/icons/baseline_menu_black_36dp.png": 483,
	"./assets/icons/clock.png": 472,
	"./assets/icons/phone.png": 471,
	"./assets/icons/plus.png": 299,
	"./assets/icons/pointer.png": 470,
	"./assets/loading.gif": 484,
	"./assets/logo/aji-logo.png": 465,
	"./assets/logo/shopnearby-logo.png": 466,
	"./assets/menu.png": 485,
	"./assets/pl.svg": 469,
	"./assets/splash.png": 669,
	"./babel.config": 486,
	"./babel.config.js": 486,
	"./package": 487,
	"./package.json": 487,
	"./src": 119,
	"./src/": 119,
	"./src/components/Addon": 210,
	"./src/components/Addon.tsx": 210,
	"./src/components/AddonsPopup": 211,
	"./src/components/AddonsPopup.tsx": 211,
	"./src/components/Address": 212,
	"./src/components/Address.tsx": 212,
	"./src/components/ArticleItem": 206,
	"./src/components/ArticleItem.tsx": 206,
	"./src/components/ArticlesList": 205,
	"./src/components/ArticlesList.tsx": 205,
	"./src/components/BreadCrumbs": 87,
	"./src/components/BreadCrumbs.tsx": 87,
	"./src/components/Cart": 77,
	"./src/components/Cart.tsx": 77,
	"./src/components/CartItemClient": 132,
	"./src/components/CartItemClient.tsx": 132,
	"./src/components/CartItemMarketplace": 213,
	"./src/components/CartItemMarketplace.tsx": 213,
	"./src/components/CartNumberItemsCircle": 127,
	"./src/components/CartNumberItemsCircle.tsx": 127,
	"./src/components/CartSummary": 131,
	"./src/components/CartSummary.tsx": 131,
	"./src/components/CategoriesDropDown": 198,
	"./src/components/CategoriesDropDown.tsx": 198,
	"./src/components/CategoriesList": 488,
	"./src/components/CategoriesList.tsx": 488,
	"./src/components/ChangePassword": 133,
	"./src/components/ChangePassword.tsx": 133,
	"./src/components/ClientHeader": 64,
	"./src/components/ClientHeader.tsx": 64,
	"./src/components/Copyright": 56,
	"./src/components/Copyright.tsx": 56,
	"./src/components/CustomerAddress": 214,
	"./src/components/CustomerAddress.tsx": 214,
	"./src/components/ErrorPopup": 215,
	"./src/components/ErrorPopup.tsx": 215,
	"./src/components/Footer": 55,
	"./src/components/Footer.tsx": 55,
	"./src/components/GalleryWithScroll": 216,
	"./src/components/GalleryWithScroll.tsx": 216,
	"./src/components/GenericProductDisplayItem": 161,
	"./src/components/GenericProductDisplayItem.tsx": 161,
	"./src/components/GenericRectangleProductDisplayItem": 113,
	"./src/components/GenericRectangleProductDisplayItem.tsx": 113,
	"./src/components/Home": 208,
	"./src/components/Home.tsx": 208,
	"./src/components/HomeHeader": 54,
	"./src/components/HomeHeader.tsx": 54,
	"./src/components/LanguagePicker": 207,
	"./src/components/LanguagePicker.tsx": 207,
	"./src/components/Login": 134,
	"./src/components/Login.tsx": 134,
	"./src/components/LoginUser": 489,
	"./src/components/LoginUser.tsx": 489,
	"./src/components/Menu": 136,
	"./src/components/Menu.tsx": 136,
	"./src/components/MenuEntry": 220,
	"./src/components/MenuEntry.tsx": 220,
	"./src/components/MobileHeader": 221,
	"./src/components/MobileHeader.tsx": 221,
	"./src/components/MyAddresses": 137,
	"./src/components/MyAddresses.tsx": 137,
	"./src/components/MyOrders": 138,
	"./src/components/MyOrders.tsx": 138,
	"./src/components/Option": 222,
	"./src/components/Option.tsx": 222,
	"./src/components/OptionGroup": 223,
	"./src/components/OptionGroup.tsx": 223,
	"./src/components/OptionPicker": 224,
	"./src/components/OptionPicker.tsx": 224,
	"./src/components/OptionsPopup": 225,
	"./src/components/OptionsPopup.tsx": 225,
	"./src/components/OrderPage": 226,
	"./src/components/OrderPage.tsx": 226,
	"./src/components/OrderPopup": 227,
	"./src/components/OrderPopup.tsx": 227,
	"./src/components/OrderStatusPopup": 228,
	"./src/components/OrderStatusPopup.tsx": 228,
	"./src/components/ProductCategory": 130,
	"./src/components/ProductCategory.tsx": 130,
	"./src/components/ProductInfo": 229,
	"./src/components/ProductInfo.tsx": 229,
	"./src/components/ProductListSortingSearch": 139,
	"./src/components/ProductListSortingSearch.tsx": 139,
	"./src/components/ProductPropositions": 231,
	"./src/components/ProductPropositions.tsx": 231,
	"./src/components/ProductsGallery": 203,
	"./src/components/ProductsGallery.tsx": 203,
	"./src/components/ProductsList": 99,
	"./src/components/ProductsList.tsx": 99,
	"./src/components/ProductsListRestaurant": 209,
	"./src/components/ProductsListRestaurant.tsx": 209,
	"./src/components/QrPopup": 232,
	"./src/components/QrPopup.tsx": 232,
	"./src/components/SortingWidget": 230,
	"./src/components/SortingWidget.tsx": 230,
	"./src/helpers/MediaQueryHelper": 49,
	"./src/helpers/MediaQueryHelper.tsx": 49,
	"./src/index": 119,
	"./src/index.tsx": 119,
	"./src/models/AccountModel": 183,
	"./src/models/AccountModel.tsx": 183,
	"./src/models/AddonModel": 125,
	"./src/models/AddonModel.tsx": 125,
	"./src/models/AddonPopupModel": 190,
	"./src/models/AddonPopupModel.tsx": 190,
	"./src/models/AddressModel": 78,
	"./src/models/AddressModel.tsx": 78,
	"./src/models/AllergenModel": 185,
	"./src/models/AllergenModel.tsx": 185,
	"./src/models/BreadCrumbModel": 73,
	"./src/models/BreadCrumbModel.tsx": 73,
	"./src/models/ClientModel": 184,
	"./src/models/ClientModel.tsx": 184,
	"./src/models/CustomerModel": 180,
	"./src/models/CustomerModel.tsx": 180,
	"./src/models/ErrorPopupModel": 192,
	"./src/models/ErrorPopupModel.tsx": 192,
	"./src/models/OptionGroupModel": 186,
	"./src/models/OptionGroupModel.tsx": 186,
	"./src/models/OptionModel": 124,
	"./src/models/OptionModel.tsx": 124,
	"./src/models/OptionPopupModel": 187,
	"./src/models/OptionPopupModel.tsx": 187,
	"./src/models/OrderItemAddonModel": 189,
	"./src/models/OrderItemAddonModel.tsx": 189,
	"./src/models/OrderItemModel": 157,
	"./src/models/OrderItemModel.tsx": 157,
	"./src/models/OrderItemOptionModel": 188,
	"./src/models/OrderItemOptionModel.tsx": 188,
	"./src/models/OrderModel": 31,
	"./src/models/OrderModel.tsx": 31,
	"./src/models/OrderPopupModel": 191,
	"./src/models/OrderPopupModel.tsx": 191,
	"./src/models/PriceModel": 58,
	"./src/models/PriceModel.tsx": 58,
	"./src/models/ProductCategoryModel": 123,
	"./src/models/ProductCategoryModel.tsx": 123,
	"./src/models/ProductModel": 91,
	"./src/models/ProductModel.tsx": 91,
	"./src/models/QrPopupModel": 194,
	"./src/models/QrPopupModel.tsx": 194,
	"./src/models/RootModel": 12,
	"./src/models/RootModel.tsx": 12,
	"./src/models/SearchStringModel": 193,
	"./src/models/SearchStringModel.tsx": 193,
	"./src/models/SortFilterModel": 106,
	"./src/models/SortFilterModel.tsx": 106,
	"./src/models/TranslatedTextModel": 53,
	"./src/models/TranslatedTextModel.tsx": 53,
	"./src/pages/AccountPage": 237,
	"./src/pages/AccountPage.tsx": 237,
	"./src/pages/AccountPageRestaurant": 238,
	"./src/pages/AccountPageRestaurant.tsx": 238,
	"./src/pages/ActivationAccountPageRestaurant": 239,
	"./src/pages/ActivationAccountPageRestaurant.tsx": 239,
	"./src/pages/CartPage": 240,
	"./src/pages/CartPage.tsx": 240,
	"./src/pages/CategoryPage": 241,
	"./src/pages/CategoryPage.tsx": 241,
	"./src/pages/ClientPage": 160,
	"./src/pages/ClientPage.tsx": 160,
	"./src/pages/CreateAccountPage": 242,
	"./src/pages/CreateAccountPage.tsx": 242,
	"./src/pages/CreateAccountPageRestaurant": 243,
	"./src/pages/CreateAccountPageRestaurant.tsx": 243,
	"./src/pages/ForgotPasswordPage": 244,
	"./src/pages/ForgotPasswordPage.tsx": 244,
	"./src/pages/ForgotPasswordPageRestaurant": 245,
	"./src/pages/ForgotPasswordPageRestaurant.tsx": 245,
	"./src/pages/HomePage": 196,
	"./src/pages/HomePage.tsx": 196,
	"./src/pages/LoginPage": 246,
	"./src/pages/LoginPage.tsx": 246,
	"./src/pages/LoginPageRestaurant": 247,
	"./src/pages/LoginPageRestaurant.tsx": 247,
	"./src/pages/ProductPage": 248,
	"./src/pages/ProductPage.tsx": 248,
	"./src/pages/ResetPasswordRestaurant": 249,
	"./src/pages/ResetPasswordRestaurant.tsx": 249,
	"./src/pages/SearchResultPage": 250,
	"./src/pages/SearchResultPage.tsx": 250,
	"./src/services/NetworkService": 30,
	"./src/services/NetworkService.tsx": 30,
	"./src/services/WebsocketService": 126,
	"./src/services/WebsocketService.tsx": 126,
	"./src/themes/AjiTheme": 93,
	"./src/themes/AjiTheme.tsx": 93,
	"./src/translations/Translations": 3,
	"./src/translations/Translations.tsx": 3,
	"./src/translations/engb": 156,
	"./src/translations/engb.tsx": 156,
	"./src/translations/frfr": 181,
	"./src/translations/frfr.tsx": 181,
	"./src/translations/plpl": 182,
	"./src/translations/plpl.tsx": 182,
	"./tsconfig": 495,
	"./tsconfig.json": 495,
	"./web-build_old/asset-manifest": 496,
	"./web-build_old/asset-manifest.json": 496,
	"./web-build_old/favicon-16.png": 695,
	"./web-build_old/favicon-32.png": 696,
	"./web-build_old/favicon.ico": 697,
	"./web-build_old/fonts/Entypo.ttf": 698,
	"./web-build_old/fonts/FontAwesome.ttf": 699,
	"./web-build_old/fonts/MaterialCommunityIcons.ttf": 700,
	"./web-build_old/fonts/Poppins-Black.ttf": 701,
	"./web-build_old/fonts/Poppins-BlackItalic.ttf": 702,
	"./web-build_old/fonts/Poppins-Bold.ttf": 703,
	"./web-build_old/fonts/Poppins-BoldItalic.ttf": 704,
	"./web-build_old/fonts/Poppins-ExtraBold.ttf": 705,
	"./web-build_old/fonts/Poppins-ExtraBoldItalic.ttf": 706,
	"./web-build_old/fonts/Poppins-ExtraLight.ttf": 707,
	"./web-build_old/fonts/Poppins-ExtraLightItalic.ttf": 708,
	"./web-build_old/fonts/Poppins-Italic.ttf": 709,
	"./web-build_old/fonts/Poppins-Light.ttf": 710,
	"./web-build_old/fonts/Poppins-LightItalic.ttf": 711,
	"./web-build_old/fonts/Poppins-Medium.ttf": 712,
	"./web-build_old/fonts/Poppins-MediumItalic.ttf": 713,
	"./web-build_old/fonts/Poppins-Regular.ttf": 714,
	"./web-build_old/fonts/Poppins-SemiBold.ttf": 715,
	"./web-build_old/fonts/Poppins-SemiBoldItalic.ttf": 716,
	"./web-build_old/fonts/Poppins-Thin.ttf": 717,
	"./web-build_old/fonts/Poppins-ThinItalic.ttf": 718,
	"./web-build_old/index.html": 719,
	"./web-build_old/manifest": 497,
	"./web-build_old/manifest.json": 497,
	"./web-build_old/pwa/apple-touch-icon/apple-touch-icon-180.png": 720,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1125x2436.png": 721,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1242x2208.png": 722,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1242x2688.png": 723,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1536x2048.png": 724,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1668x2224.png": 725,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-1668x2388.png": 726,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-2048x2732.png": 727,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-640x1136.png": 728,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-750x1334.png": 729,
	"./web-build_old/pwa/apple-touch-startup-image/apple-touch-startup-image-828x1792.png": 730,
	"./web-build_old/pwa/chrome-icon/chrome-icon-144.png": 731,
	"./web-build_old/pwa/chrome-icon/chrome-icon-192.png": 732,
	"./web-build_old/pwa/chrome-icon/chrome-icon-512.png": 733,
	"./web-build_old/serve": 498,
	"./web-build_old/serve.json": 498,
	"./web-build_old/static/js/2.b7a83e5a.chunk": 499,
	"./web-build_old/static/js/2.b7a83e5a.chunk.js": 499,
	"./web-build_old/static/js/2.b7a83e5a.chunk.js.LICENSE.txt": 734,
	"./web-build_old/static/js/2.b7a83e5a.chunk.js.map": 735,
	"./web-build_old/static/js/app.b7a31d20.chunk": 500,
	"./web-build_old/static/js/app.b7a31d20.chunk.js": 500,
	"./web-build_old/static/js/app.b7a31d20.chunk.js.map": 736,
	"./web-build_old/static/js/runtime~app.2e9f1821": 501,
	"./web-build_old/static/js/runtime~app.2e9f1821.js": 501,
	"./web-build_old/static/js/runtime~app.2e9f1821.js.map": 737,
	"./web-build_old/static/media/OFL.7f788d6c.txt": 738,
	"./web-build_old/static/media/adaptive-icon.e4e80208.png": 739,
	"./web-build_old/static/media/aji-logo.32eac5a0.png": 740,
	"./web-build_old/static/media/allergen_celery.248ebf11.png": 741,
	"./web-build_old/static/media/allergen_crustacena.c0f1e8de.png": 742,
	"./web-build_old/static/media/allergen_eggs.665b8d7b.png": 743,
	"./web-build_old/static/media/allergen_fish.449817e7.png": 744,
	"./web-build_old/static/media/allergen_lupin.e6f69126.png": 745,
	"./web-build_old/static/media/allergen_milk.871192d4.png": 746,
	"./web-build_old/static/media/allergen_molluscs.87a884ef.png": 747,
	"./web-build_old/static/media/allergen_mustard.275942f0.png": 748,
	"./web-build_old/static/media/allergen_peanut.c4b898de.png": 749,
	"./web-build_old/static/media/allergen_sesame.8e0c6adc.png": 750,
	"./web-build_old/static/media/allergen_soya.b975538d.png": 751,
	"./web-build_old/static/media/allergen_sulphurdioxide.f92936a7.png": 752,
	"./web-build_old/static/media/allergen_treenut.8fb7ba75.png": 753,
	"./web-build_old/static/media/allergen_wheat.e314578f.png": 754,
	"./web-build_old/static/media/cart.9dec99fe.png": 755,
	"./web-build_old/static/media/clock.0f20feea.png": 756,
	"./web-build_old/static/media/cooking.7a3c44db.gif": 757,
	"./web-build_old/static/media/en.70e4e37f.svg": 758,
	"./web-build_old/static/media/favicon.fa4783d1.png": 759,
	"./web-build_old/static/media/icon.608e4d9d.png": 760,
	"./web-build_old/static/media/loading.63305967.gif": 761,
	"./web-build_old/static/media/menu.a45269fd.png": 762,
	"./web-build_old/static/media/phone.4e1be1a5.png": 763,
	"./web-build_old/static/media/pointer.ba78b77f.png": 764,
	"./web-build_old/static/media/shopnearby-logo.17495fff.png": 765,
	"./web-build_old/static/media/splash.63d56b17.png": 766,
	"./web-build_old/static/media/yarn.a7fa3337.lock": 767,
	"./yarn.lock": 768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;